import React, { useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { makeStyles, Button, InputLabel, FormHelperText, CircularProgress } from '@material-ui/core';
import { Editor } from '@tinymce/tinymce-react';

import ErrorValidationAlert from '../alerts/ErrorValidationAlert';
import ownerService from '../../services/ownerService';

const useStyles = makeStyles((theme) => ({
    label: {
		marginBottom: '10px',
		textAlign: 'left',
		fontWeight: 500,
		fontSize: '16px',
		color: 'rgba(0, 0, 0, 0.87)'
	}
}));

const formSchema = Yup.object().shape({
    message: Yup.string().max('1500', 'Must be 1500 characters or less.').required('Message field is required.')
});

const TINYMCE_API_KEY = process.env.REACT_APP_TINYMCE_API_KEY;

const ReplyForm = (props) => {

    const classes = useStyles();
    const [errors, setErrors] = useState("");
    const [loading, setLoading] = useState(true);

    const handleReply = (values, formikBag) => {
    
        setErrors("")
        const { setSubmitting, resetForm } = formikBag;

        const formData = new FormData();
        formData.append('message', values.message);
        formData.append('review_id', values.review_id);
        formData.append('reply_type', values.reply_type);

        ownerService.storeReviewOtherReply(formData)
                .then((res) => {
                    setSubmitting(false)
                    if(res.data.success) {
                        resetForm(true)
                        props.setConfirmation(true)
                    }
                })
                .catch((error) => {
                    setSubmitting(false)
                    if(error.response.data.errors) {
                        setErrors(error.response.data.errors)
                    }
                })
    }

    return (
        <>

            {errors && (
                <ErrorValidationAlert
                    errors={errors} 
                />
            )}

            <Formik 
                initialValues={{ 
                    message: '',
                    review_id: props.reviewId,
                    listing_id: props.listingId,
                    reply_type: props.replyType
                }}
                validationSchema={formSchema}
                onSubmit={handleReply}
            >
                {formik => (
                    <form onSubmit={formik.handleSubmit}>
                        <div className="row mt-2">
                            <div className="col-md-12 col-sm-12 col-xs-12">
                                <InputLabel className={classes.label}>{props.replyType === "direct-message" ? "Your Message" : "Your Public Comment"}</InputLabel>
                                {loading && (
                                    <div className="pt-4 pb-4">
                                        <CircularProgress
                                            thickness={4.0}
                                            size={24}
                                            color="secondary"
                                        />
                                    </div>
                                )} 
                                <Editor
                                    apiKey={TINYMCE_API_KEY}
                                    onInit={() => {
                                        setLoading(false);
                                    }}
                                    init={{
                                        height: 250,
                                        content_style: "body { line-height: 1.3; }",
                                        menubar: false,
                                        toolbar: false,
                                        statusbar: false
                                    }}
                                    plugins="wordcount"
                                    textareaName="message"
                                    //	value={props.formik.values.message}
                                    // {...formik.getFieldProps('description')}
                                    onEditorChange={(content, editor) => {
                                        formik.setFieldValue('message', content, true)
                                    }}
                                    error={true}
                                />
                                {formik.errors.message && 
                                    <FormHelperText error={true}>{formik.errors.message}</FormHelperText>
                                }
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 col-sm-12 col-xs-12">
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    disabled={formik.isSubmitting}
                                    className="mt-3 mb-2"
                                    type="submit"
                                >
                                    {formik.isSubmitting && <CircularProgress size={24} />}
                                    {!formik.isSubmitting && 'Send Message'}    
                                </Button>
                            </div>
                        </div>
                    </form>
                )}
            </Formik>
        </>
    );
};

export default ReplyForm;